angular.module('qkr').directive('templateRecord', ['formBuilderService', 'FormHelper', '$timeout',
	'gettextCatalog', 'messageService', function(formBuilderService, FormHelper, $timeout, gettextCatalog,
                                                 messageService) {

	return {
		restrict: 'E',
		scope: {
			template: '='
		},
		template: require('../../directives/forms/template_record.html'),
		replace: true,
		link(scope, element, attrs, controller) {
			scope.deleteTemplate = function() {
				formBuilderService.deleteTemplate(scope.template.id).then((response) => {
					const formHelper = new FormHelper(scope);
					const resp = formHelper.handleResponse(response);

					if (resp.success) {
						$timeout(() => {
		                    scope.$emit('reloadTemplates');
		                });
					} else {
						messageService.error(gettextCatalog.getString('Error, template could not be deleted'));
					}
				});
			};
            scope.formatDateUpdated = function(dateMillis) {
                return new Date(dateMillis).format('dd-mmm-yyyy');
            };
		}
	};
}]);



// WEBPACK FOOTER //
// ./src/directives/forms/template_record.js